import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { postAccumulation } from '../../api/login'
import { getAccumulations } from '../../api/profile'
import { fadeIn, fadeOut, slideDown, slideUp } from '../../js/animation'
import { plusComma } from '../../js/script'

/**
 * 모달 팝업 - 섬 모양
 *
 * @params content - 콘텐츠 내용
 */

export default function PointExchange({
  setIsModal,
  coin,
  memberNo,
  setPointChange,
}: {
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>
  coin?: number
  memberNo?: any
  setPointChange: React.Dispatch<React.SetStateAction<boolean>>
}) {
  const [closing, setClosing] = useState<boolean>(false) // 닫힘 애니메이션 적용에 필요
  const [accumulation, setAccumulation] = useState<number>(0)
  const [changePoint, setChangePoint] = useState<number>(0)

  // body 스크롤 제어
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  const closeModal = () => {
    setClosing(true)

    setTimeout(() => {
      setIsModal(false)
      setClosing(false)
    }, 280)
  }

  useEffect(() => {
    getAccumulations('')
      .then((res) => {
        setAccumulation(res.data.totalAmt)
      })
      .catch((err) => console.log(err))
  }, [])

  function isThousands(value: string) {
    // 정규식을 사용하여 1000단위로 쉼표가 있는지 확인합니다.
    // 예: '1,000', '10,000', '100,000' 등
    const regex = /^\d{1,3}(,\d{3})*$/
    return regex.test(value)
  }

  return (
    <ModalWrap>
      <ModalBox closing={closing}>
        <ModalHeader>
          <p>적립금 전환</p>
          <button type='button'>
            <img
              src='../../images/icon_close.png'
              alt=''
              onClick={() => {
                closeModal()
              }}
            />
          </button>
        </ModalHeader>
        <ModalBody>
          <PointExchangePop>
            <div className='pop_wrap'>
              <div className='exchange_wrap'>
                <div className='top_coin'>
                  <span>보유 적립금</span>
                  <strong>{plusComma(accumulation)}</strong>
                  <img src='' alt='' />
                </div>
                <div className='my_coin'>
                  <div className='tit'>
                    <p>보유 피싱코인</p>
                    <strong>{coin ? plusComma(coin) : 0}</strong>
                  </div>
                  <div className='inp_cont'>
                    <div className='inp_box'>
                      <input
                        type='text'
                        placeholder='0'
                        inputMode='numeric'
                        value={plusComma(Number(changePoint))}
                        onChange={(e) => {
                          setChangePoint(Number(e.target.value.replace(/,/g, '')))
                        }}
                        onBlur={() => {
                          console.log(isThousands(plusComma(changePoint)))
                        }}
                      />
                      {changePoint ? (
                        <button
                          type='button'
                          onClick={() => {
                            setChangePoint(0)
                          }}
                        ></button>
                      ) : null}
                    </div>
                    <button
                      className='exchange'
                      type='button'
                      onClick={() => {
                        setChangePoint(coin || 0)
                      }}
                    >
                      전액 사용
                    </button>
                  </div>
                </div>
                <div className='info_txt'>
                  <ul>
                    <li>1원의 적립금은 현금의 가치와 동일합니다.</li>
                    <li>적립금은 1,000 단위로 전환이 가능합니다.</li>
                    <li>적립금으로 전환된 피싱코인은 환불이 불가합니다.</li>
                    <li>적립금의 유효기간은 전환/지급일로 부터 1년입니다.</li>
                  </ul>
                </div>
              </div>
              <div
                className='btn_cont'
                style={{
                  marginTop: '0px',
                }}
              >
                <button
                  type='button'
                  className='btn_border'
                  onClick={() => {
                    closeModal()
                  }}
                >
                  취소
                </button>
                <button
                  type='button'
                  className='btn_fill'
                  onClick={() => {
                    if (Number(changePoint) === 0 || isNaN(Number(changePoint))) {
                      alert('전환할 피싱코인을 입력해 주세요')
                      return
                    }
                    if (Number(changePoint) % 1000 > 0) {
                      alert('1,000원 단위로만 전환 가능합니다')
                      return
                    }

                    if (Number(changePoint) <= Number(coin)) {
                      const confirm = window.confirm('적립금을 전환하시겠습니까?')
                      if (confirm) {
                        postAccumulation(changePoint, memberNo)
                          .then((res) => {
                            alert('전환 되었습니다.')
                            closeModal()
                            setPointChange((prev: any) => !prev)
                          })
                          .catch((err) => {})
                      }
                    } else {
                      alert('보유 피싱코인이상으로 전환 할 수 없습니다.')
                    }
                  }}
                >
                  전환
                </button>
              </div>
            </div>
          </PointExchangePop>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalBox>
      <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
    </ModalWrap>
  )
}
interface typeProps {
  closing?: boolean
}
export const ModalBackground = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'closing',
})<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
`

export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 20;
`
export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18.5px 22px 0 33px;
  & p {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    padding: 12px 0;
    color: var(--colBlack);
  }
  & button {
    border: 0;
    padding: 12px 8px 12px 9px;
    margin: 0;
    background: transparent;
    width: 41px;
    height: 48px;
    & img {
      width: 100%;
    }
  }
`
export const ModalBox = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'closing',
})<typeProps>`
  width: 100%;
  background-color: var(--colWhite);
  border-radius: 22px 22px 0 0;
  animation: ${({ closing }) => (closing ? slideDown : slideUp)} 0.3s ease-in-out;
  position: absolute;
  z-index: 30;
  display: flex;
  flex-direction: column;
  bottom: 0;
`
export const ModalBody = styled.div``
export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
`

const PointExchangePop = styled.div`
  & .pop_wrap {
    & .exchange_wrap {
      padding: 0 33px 24px 33px;
      & .top_coin {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 20px;
        & span {
          display: inline-block;
          font-size: 13px;
          line-height: 16px;
          color: #898989;
          margin-right: 6px;
          font-weight: 400;
        }
        & strong {
          position: relative;
          display: inline-block;
          font-size: 16px;
          line-height: 20px;
          color: var(--colBlack);
          font-weight: 700;
          &:after {
            content: '';
            display: inline-block;
            width: 12px;
            height: 12px;
            background: url('../../images/icon_point.png') no-repeat;
            background-size: contain;
            margin-left: 2px;
          }
        }
      }
      & .my_coin {
        display: flex;
        gap: 20px;
        flex-direction: column;
        & .tit {
          display: flex;
          flex-direction: column;
          & p {
            font-size: 13px;
            line-height: 16px;
            color: var(--colBlack);
            margin-bottom: 4px;
          }
          & strong {
            position: relative;
            display: inline-block;
            font-size: 26px;
            line-height: 32px;
            color: var(--colBlack);
            font-weight: 700;
            &:after {
              content: '';
              display: inline-block;
              width: 14px;
              height: 14px;
              background: url('../../images/icon_coin.png') no-repeat;
              background-size: contain;
              margin-left: 2px;
            }
          }
        }

        & .inp_cont {
          display: flex;
          gap: 8px;
          justify-content: space-between;
          & .inp_box {
            width: 100%;
            position: relative;
            & input {
              width: 100%;
              font-size: 20px;
              line-height: 24px;
              color: var(--colBlack);
              padding: 11px 14px;
              border: 1px solid var(--colGray3);
              border-radius: 5px;
              font-weight: 700;
            }
            & button {
              position: absolute;
              top: 12px;
              right: 8px;
              width: 24px;
              height: 24px;
              background: url('../../images/icon_clear_button_gray.png') no-repeat;
              background-size: contain;
              border: 0;
            }
          }
          & .exchange {
            text-align: center;
            font-size: 14px;
            line-height: 16px;
            color: var(--colWhite);
            padding: 16px 0;
            min-width: 85px;
            font-weight: 500;
            background: var(--colBlack);
            border-radius: 6px;
            border: 0;
          }
        }
      }

      & .info_txt {
        margin-top: 24px;
        & ul {
          display: flex;
          gap: 4px;
          flex-direction: column;
          & li {
            position: relative;
            font-size: 13px;
            line-height: 16px;
            color: var(--colGray6);
            padding-left: 8px;
            font-weight: 400;
            &:before {
              content: '';
              position: absolute;
              top: 7px;
              left: 2px;
              width: 2px;
              height: 2px;
              border-radius: 50%;
              background: var(--colGray6);
            }
          }
        }
      }
    }

    & .btn_cont {
      padding: 12px 33px;
      display: flex;
      gap: 8px;
      justify-content: space-between;
      & button {
        margin: 0;
        padding: 0;
        border: 0;
        background: transparent;
        font-size: 14px;
        line-height: 24px;
        border-radius: 5px;
        width: 100%;
        font-weight: 500;
      }
      & .btn_border {
        color: var(--colBlack);
        border: 1px solid var(--colGray3);
        padding: 11px 0;
      }
      & .btn_fill {
        color: var(--colWhite);
        background: var(--colBlack);
        padding: 12px 0;
      }
    }
  }
`
